import DateFilter from '@/components/date-filter';
import $ from 'jquery'

export default {
    name: 'salle-examen',
    components: {
        DateFilter
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,


            files: [],
            sv_loading: false,
            btn_disable: false,

            result_to_fill: {
                demande_id: 0,
                examen_nom: '',
                result_examen: null,
                examen_commentaire: ''
            },
            one_is_empty: false,
			both_is_empty: false,
            is_error: false,
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,

            fields: [ 
                {key:'patient', label: 'Patient'}, {key:'telephone', label: 'Téléphone'}, 'sexe',
                {key:'resultat',label: 'Porter résultat'}
            ],
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                etat_resultat: 0,
                user_id: this.userCredentials.id,
                type_examen_id: this.$route.params.examen_id
            }
            this.current_date_filter = data
            this.is_month = true
            this.getListExamenToFill()
        },
    },

    computed: {
        examen_to_flll() {
            return this.$store.getters['examen_to_flll']
        },

        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },

        selected_date_filter() {
            return this.$store.getters['selected_date_filter']
        },
    },

    mounted() {
        this.current_date_filter = this.selected_date_filter
        this.current_date_filter.type_examen_id = this.$route.params.examen_id

        this.getListExamenToFill()
    },

    methods: {
        handleFilesUpload() {
			let uploadedFiles = this.$refs.files.files;
			/*
				Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}

            this.result_to_fill.result_examen = this.files[0];
            this.clearAll()
		},

        getListExamenToFill() {
            this.is_loading = true
            this.$store.dispatch('getExamenToFill', this.current_date_filter).then(() => {
                if(this.examen_to_flll.l_patient.length > 0) {
                    this.is_empty = false 
                } else {
                    this.is_empty = true
                } 
                this.is_loading = false
            })
        },

        fillResult(data, demande_id, patient) {
            this.files = []
			this.clearAll()
            this.result_to_fill = {
                patient: patient,
                demande_id: demande_id,
                examen_nom: data.examen,
                examen_commentaire: '',
                result_examen: null,
            }

            $('.result-exam').modal('show')
        },

        saveResultat() {

			let comment_is_empty = false,
				file_is_empty = false

			if (this.result_to_fill.examen_commentaire == '') {
				comment_is_empty = true
			}

			if (this.result_to_fill.result_examen == null) {
				file_is_empty = true
			}

			let confirm = document.getElementById('cfrm-exm-result');
			

			if (comment_is_empty && file_is_empty) {
				this.sv_loading = false
				this.btn_disable = false
				this.both_is_empty = true

				return;
			} else if (
				( (!comment_is_empty && file_is_empty) || (comment_is_empty && !file_is_empty) ) && 
				(!confirm || confirm.checked == false)
			) {
				this.sv_loading = false
				this.btn_disable = false
				this.one_is_empty = true
				if (confirm && confirm.checked == false) {
					$('.err-msg').fadeIn(500)
				}

				return;
			} 

            let max_file_size = 1024
            if (!file_is_empty) {
                if (!this.fileValidation(max_file_size, 'files')) {

                    return
                }
            }
			

			this.sv_loading = true

            let data = {
                demande_id: this.result_to_fill.demande_id,
                commentaire: this.result_to_fill.examen_commentaire,
                result_examen: this.result_to_fill.result_examen
            }

            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }

            this.$store.dispatch('saveResultatExamen', form_data).then((response) => {
                if (response > 0) {
                    this.successMsg("Résultat enregistré avec succès")
					this.getListExamenToFill()

                    this.result_to_fill = {
                        demande_id: 0,
                        examen_nom: '',
                        result_examen: null,
                        examen_commentaire: ''
                    }
                    this.files = []
					this.clearAll()

                    $('.modal').modal('hide')
					
                    
                } else {
                    this.errorMsg('Une erreur est survenue! Merci de réessayer.')
                }
				this.sv_loading = false
            }).catch(() => {
				this.is_error = true
                this.sv_loading = false
            })
        },

		successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

		errorMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-danger',
                type: 'danger',
                position: 'top-center'

            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
		onConfirm() {
            $('.err-msg').fadeOut(500);
        },

		clearAll() {
            this.both_is_empty = false 
			this.one_is_empty = false
			this.is_error = false
			$('.err-msg').fadeOut(500)
			$('.err-fsize').fadeOut(500)
			$('.err-extension').fadeOut(500)
		},

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                etat_resultat: 0,
                user_id: this.userCredentials.id,
                type_examen_id: this.$route.params.examen_id
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.getListExamenToFill()
        },
    }
}


